<template>
    <div v-if="show" class="Export-Plan">
        <div class="Button-Group">
            <i class="el-icon-circle-close Close" @click="show=false"></i>
            <!-- <el-button type="" class="Send-Sheceme" size="mini" @click="sendPlan">发送方案</el-button> -->
            <!--            <div class="Edit">-->
            <!--                <el-button type="" class="Edit-Button">宣传DM图编辑</el-button>-->
            <!--                <el-button type="" class="Edit-Button Net-Edit">图文版行程概览编辑</el-button>-->
            <!--            </div>-->
            <div class="Edit Share">
                <el-button type="" class="Edit-Button" @click="shareWord">方案分享</el-button>
                <el-button type="" class="Edit-Button Net-Edit" @click="referenceHotel">参考酒店分享</el-button>
                <el-button type="" class="Edit-Button Net-Edit">宣传DM图分享</el-button>
            </div>
            <el-button type="" class="Put-App" size="mini" @click="applySysPlan">申请放入公共行程库</el-button>
        </div>
        <planWordScheme v-show="show" @closeDialog="closeDialog" ref="scheme" :checkBudget="checkBudget"
                        :showPlanSendButton="showPlanSendButton"></planWordScheme>
        <QrShare v-show="show" ref="qr"></QrShare>
        <planMap v-show="show" @closeDialog="closeDialog" ref="planMapShow" @allowExport="allowExport"></planMap>
        <refer-hotel-list-dialog ref="referHotelList" @closeDialog="closeDialog"></refer-hotel-list-dialog>
    </div>
</template>

<script>
// 这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
import planWordScheme from '@/views/plan/leftMoudle/dialog/planWordScheme'
import QrShare from './QrShare.vue'
import PlanApi from '@/components/Api/PlanApi.js'
import planMap from './planMap.vue'
import ReferHotelListDialog from './referHotelListDialog.vue'

export default {
    name: '',
    components: {planWordScheme, QrShare, planMap, ReferHotelListDialog},
    // 定义属性
    data() {
        return {
            show: false,
            hide: false,
            budgetMainId: -1,
            planId: -1
        }
    },
    // 计算属性，会监听依赖属性值随之变化
    computed: {},
    // 监控data中的数据变化
    watch: {},
    // 方法集合
    methods: {
        closeDialog() {
            this.show = false
        },
        referenceHotel() {
            this.$refs.referHotelList.openDialog(this.budgetMainId)
        },
        init(budgetMainId, planId) {
            this.show = true
            this.budgetMainId = budgetMainId
            this.planId = planId
        },
        shareWord() {
            this.$refs.scheme.init()
            // this.$refs.planMapShow.init()
        },
        allowExport() {
            this.$refs.scheme.init()
            // this.$refs.planMapShow.close()
            // this.show = false
        },
        shareQr() {
            this.$refs.planMapShow.init()
        },
        applySysPlan() {
            new PlanApi("plan").applySysPlan({id: this.budgetMainId}).then(res => {
                if (res.status == 200) {
                    this.$message.success("申请成功")
                } else {
                    this.$message.error(res.statusText)
                }
            }).catch(() => {
                this.$message.error("系统异常")
            })
        }
    },
    // 生命周期 - 创建完成（可以访问当前this实例）
    created() {

    },
    // 生命周期 - 挂载完成（可以访问DOM元素）
    mounted() {

    },
    props: {
        checkBudget: {
            type: Object,
            default: () => {
                return {}
            }
        },
        showPlanSendButton: {
            type: String,
            default: '',
        }
    },
    beforeCreate() {
    }, // 生命周期 - 创建之前
    beforeMount() {
    }, // 生命周期 - 挂载之前
    beforeUpdate() {
    }, // 生命周期 - 更新之前
    updated() {
    }, // 生命周期 - 更新之后
    beforeDestroy() {
    }, // 生命周期 - 销毁之前
    destroyed() {
    }, // 生命周期 - 销毁完成
    activated() {
    }, // 如果页面有keep-alive缓存功能，这个函数会触发
}
</script>

<style scoped lang="scss">
.Hide {

}

.Export-Plan {
    width: 2.3rem;
    position: fixed;
    // z-index: 3000 !important;
    top: 2.5rem;
    left: 3.1rem;
    // border: 0.027rem solid #d04a19;
    // box-shadow: #d04a19 0rem -0.005rem 0.05rem 0rem;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    background: white;
    z-index: 12;

    .Close {
        text-align: end;
        position: relative;
        bottom: 6px;
        font-size: 16px;
        font-weight: 700;
    }

    .Button-Group {
        display: flex;
        flex-direction: column;
        padding: 10px;
        border: 0.027rem solid #d04a19;

        .Put-App {
            background-color: rgb(208, 74, 25);
            color: white;
            font-size: 12px;
        }

        .Share {
            margin-top: 0px !important;
        }

        .Edit {
            padding: 10px 0px 10px 0;
            border: 1px solid #f7f2f2;
            border-radius: 5px;
            margin-bottom: 20px;
            margin-top: 20px;
            text-align: center;

            .Edit-Button {
                width: 90% !important;
                margin-left: 0;
                width: 155px;
                background: #f6f6f6;
                text-align: center;
                color: #d04a19;
                font-size: 12px;
            }

            .Net-Edit {
                margin-top: 5px;
            }
        }
    }
}
</style>